/*
 * Copyright (c) 2023 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FabMessageService } from '@fabric/components/message';

@Component({
    selector: 'app-manage-attribute-popup',
    templateUrl: './update-attribute-popup.component.html',
    styleUrls: ['./update-attribute-popup.component.scss'],
    standalone: false
})
export class UpdateAttributePopupComponent {
  attributeForm: FormGroup;
  title: string;
  currentValueToUpdate: string;
  attribute: string;
  maxLength: number;
  showSpinner: boolean;
  isValidVehicleType: boolean;
  validVehicleTypes = ['CAR', 'TRUCK', 'ND'];

  constructor(@Inject(MAT_DIALOG_DATA) private data: any,
              public dialogRef: MatDialogRef<UpdateAttributePopupComponent>,
              public snackBar: FabMessageService) {
    if (data) {
      this.title = data.header;
      this.currentValueToUpdate = data.selectedValue;
      this.attribute = data.attributeToUpdate;
      this.maxLength = data.maxLength;
    }

    this.attributeForm = new FormGroup({
      currentValue: new FormControl({value: this.currentValueToUpdate, disabled: true}, Validators.required),
      newValue: new FormControl(this.attributeForm, [Validators.required])
    });
  }

  /**
   * Close popup window.
   */
  onCancel(): void {
    this.dialogRef.close();
  }

  /**
   * Return new value to preview changes.
   */
  previewChanges(): void {
    this.dialogRef.close({
      data: {
        isPreviewChange: true,
        newValue: this.attributeForm.controls.newValue.value
      }
    });
  }

  /**
   * Return new value to commit changes.
   */
  commitChanges(): void {
    this.dialogRef.close({
      data: {
        isPreviewChange: false,
        newValue: this.attributeForm.controls.newValue.value
      }
    });
  }

  /**
   * Disable commit and preview button:
   * If new value is empty, or
   * If updating vehicle type, and users input is NOT equal to either 'car', 'truck' or 'nd'.
   */
  validateInput(): boolean {
    if (!this.attributeForm.invalid && this.title === 'Vehicle Types' &&
      this.validVehicleTypes.indexOf(this.attributeForm.controls.newValue.value) === -1) {
      return true;
      }
    return this.attributeForm.invalid;
  }

}
